// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { controlsContainerStyles } from "@tps/Overrides/Widgets/ProductList/ProductListControlsContainer";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

controlsContainerStyles.filterResultsGridItem = {
    width: [6, 6, 6, 0, 0],
    css: css`
        &&& {
            margin: 8px 0;
        }
    `,
};
controlsContainerStyles.paginationGridItem = {
    width: [6, 6, 6, 8, 8],
    css: css`
        padding-left: 24px;
        span[class^="PerPageSelect-"] {
            ${xScreen("lte", "md")} {
                display: none;
            }
        }
        ${xScreen("lte", "xs")} {
            padding-left: 8px;
        }
    `,
};
controlsContainerStyles.sortGridItem = {
    width: [0, 0, 0, 4, 4],
    css: css`
        padding: 12px 0;
    `,
};

controlsContainerStyles.container = {
    gap: 0,
    offsetCss: css`
        align-items: center;
        padding: 0 12px;
    `,
    css: css`
        background-color: ${color("common.ui2")};
    `,
};
